var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-380.856 -351.344)"},[React.createElement("path",{"d":"M390.525,358.4l9.283-6.429a1.685,1.685,0,0,0-1.306-.626H382.748a1.694,1.694,0,0,0-1.4.745Z","transform":"translate(-0.196 0)","key":0}),React.createElement("path",{"d":"M390.329,361.827l-9.473-6.633v10.879a1.7,1.7,0,0,0,1.7,1.7h15.754a1.7,1.7,0,0,0,1.7-1.7V355Z","transform":"translate(0 -1.467)","key":1})]));
}

Mail.defaultProps = {"width":"19.146","height":"14.958","viewBox":"0 0 19.146 14.958"};

module.exports = Mail;

Mail.default = Mail;
